(function(){
  /* Cookie consent is handled by Shopify's native Customer Privacy banner.
     The custom #md-cookie-banner was removed in theme 9.7 — it duplicated the native banner. */

  /* ===== Terms & Conditions agreement checkbox at cart/checkout ===== */
  var TERMS='/pages/terms-of-service';
  var PRIV='/pages/privacy-policy';
  function makeBox(){
    var w=document.createElement('div');
    w.className='md-terms-agree';
    w.style.cssText='margin:14px 0;';
    w.innerHTML='<label style="display:flex;gap:9px;align-items:flex-start;font-size:13px;line-height:1.45;font-family:Arial,Helvetica,sans-serif;color:#1a2b4a;cursor:pointer;"><input type="checkbox" class="md-terms-cb" style="margin-top:2px;width:16px;height:16px;flex-shrink:0;accent-color:#001489;"><span>I agree to the <a href="'+TERMS+'" target="_blank" rel="noopener" style="color:#001489;text-decoration:underline;">Terms &amp; Conditions</a> and <a href="'+PRIV+'" target="_blank" rel="noopener" style="color:#001489;text-decoration:underline;">Privacy Policy</a>.</span></label>';
    return w;
  }
  function guard(btn){
    if(!btn||btn.dataset.mdTerms)return;
    btn.dataset.mdTerms='1';
    var box=makeBox();
    try{btn.parentElement.insertBefore(box,btn);}catch(e){return;}
    var cb=box.querySelector('.md-terms-cb');
    btn.addEventListener('click',function(e){
      if(!cb.checked){
        e.preventDefault();e.stopImmediatePropagation();
        box.style.cssText='margin:14px 0;outline:2px solid #c0392b;border-radius:6px;padding:8px;background:rgba(192,57,43,.05);';
        cb.focus();
        return false;
      }
    },true);
  }
  function scan(){
    document.querySelectorAll('[name="checkout"],button[name="checkout"],.cart__checkout-button,[data-checkout-button],a[href^="/checkout"]').forEach(guard);
  }
  if(document.readyState!=='loading'){scan();}else{document.addEventListener('DOMContentLoaded',scan);}
  try{var mo=new MutationObserver(function(){scan();});mo.observe(document.documentElement,{childList:true,subtree:true});}catch(e){}
})();
